//eslint-disable-next-line
export function isEmail(email:string):boolean{
return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email)
}
